"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleMobileLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  const slidingUnderlineClasses = "relative py-1 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-primary after:transition-transform after:duration-300 hover:after:origin-bottom-left hover:after:scale-x-100 uppercase tracking-widest text-xs font-medium font-mono text-foreground/80 hover:text-primary transition-colors";
  return <div data-section-id="69698" className="container mx-auto px-4 h-20 flex items-center justify-between">
      {}
      <div className="flex items-center shrink-0">
        <Link to="/HomePage" className="flex items-center z-50 relative">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575279/img/image_4rbkzwk0.png" alt="DB Hockey Advancement" className="h-7 w-auto object-contain" />
          <span className="ml-2.5 text-lg font-bold tracking-tighter uppercase font-sans text-foreground">
            DB Hockey Advancement
          </span>
        </Link>
      </div>

      {}
      <div className="hidden md:flex items-center">
        {loading ? <div className="flex gap-6">
            {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 bg-muted/20 animate-pulse rounded-sm" />)}
          </div> : <NavigationMenu viewport={false}>
            <NavigationMenuList className="gap-8">
              {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className={slidingUnderlineClasses}>
                      {item.label}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>}
      </div>

      {}
      <div className="md:hidden flex items-center z-50 relative">
        <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" className="text-foreground hover:bg-primary/10 rounded-sm">
          {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      {}
      <div className={`fixed inset-0 bg-background/95 backdrop-blur-2xl z-40 transition-all duration-300 ease-in-out md:hidden flex flex-col pt-24 px-6 ${isMobileMenuOpen ? "opacity-100 pointer-events-auto translate-y-0" : "opacity-0 pointer-events-none -translate-y-4"}`}>
        <nav className="flex flex-col gap-6 items-center text-center">
          {loading ? <div className="flex flex-col gap-6 items-center w-full">
              {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-8 w-32 bg-muted/20 animate-pulse rounded-sm" />)}
            </div> : menuItems.map((item, i) => <div key={item.id} data-index={i} className="w-full border-b border-border/30 pb-4">
                <Link to={item.href || "#"} className="text-lg uppercase tracking-widest font-bold font-sans text-foreground hover:text-primary transition-colors block w-full" onClick={handleMobileLinkClick}>
                  {item.label}
                </Link>
              </div>)}
        </nav>
      </div>
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="header" className={`dark bg-background text-foreground sticky top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border shadow-lg" : "bg-background border-b border-transparent"}`}>
      <MenuProvider menu_id="38" className="w-full h-full">
        <HeaderContent />
      </MenuProvider>
    </header>;
}